import axios from "axios";

export default {
  index(query) {
    return axios.get("/api/staffs", {
      params: {
        per_page: query.per_page,
        page: query.page
      }
    });
  },
  staffsList(query) {
    return axios.get("/api/staffs_list", {
      params: {
        per_page: query.per_page,
        page: query.page
      }
    });
  },
  staffsNetcampusList() {
    return axios.get("/api/staffs_netcampus_list");
  },
  staffsFilterIds() {
    return axios.get("/api/staffs_filter_ids");
  },
  staffWithPermission(permission) {
    return axios.get("/api/staffs/permission/" + permission);
  },
  staffAllPermission(permission) {
    return axios.get("/api/staffs/all/permission/" + permission);
  },
  staffWithRole(role) {
    return axios.get("/api/staffs/role/" + role);
  },
  addUser(query) {
    return axios.post("/api/staffs/add", {
      params: {
        first_name: query.first_name,
        last_name: query.last_name,
        password: query.password,
        email: query.email
      }
    });
  },
  getSchedules() {
    return axios.get("/api/candidate/application/schedule");
  },
  getFinanceSchedules() {
    return axios.get("/api/candidate/finances/schedule");
  },
  getTotalStaffTasks() {
    return axios.get("/api/dashboard/tasks/staff/total");
  },
  getStaffTasks(query) {
    return axios.get("/api/dashboard/tasks/staff", {
      params: {
        staff: query.staff,
        per_page: query.perPage,
        page: query.page,
        search: query.search
      }
    });
  },
  getStaffSchedules(query) {
    return axios.get("/api/candidate/application/schedule/staff", {
      params: {
        date: query.date
      }
    });
  },
  getAppointmentSchedules(query) {
    return axios.get("/api/candidate/application/appointments", {
      params: {
        date: query.date
      }
    });
  },
  getApplicationsInterviewers(query) {
    return axios.get("/api/candidate/application/interviewers");
  },
  getOldStaffSchedules(query) {
    return axios.get("/api/candidate/application/old_schedule/staff", {
      params: {
        date: query.date
      }
    });
  },
  getStaffMessages() {
    return axios.get("/api/dashboard/messages/staff");
  },
  getStaffFinanceSchedules() {
    return axios.get("/api/candidate/finances/schedule/staff");
  },
  deleteUser(data) {
    return axios.post("/api/staff/delete", data);
  },
  showUser(id) {
    return axios.get("/api/staff/" + id);
  },
  updateUser(id, query) {
    return axios
      .post("/api/staff/" + id + "/edit", query)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error.response;
      });
  },
  toggleActive(id) {
    return axios.get("/api/staff/toggleActive/" + id);
  },
  roles() {
    return axios.get("/api/roles");
  },
  createRole(data) {
    return axios.post("/api/role/create", data);
  },
  updateRole(data) {
    return axios.post("/api/role/update", data);
  },
  deleteRole(data) {
    return axios.post("/api/role/delete", data);
  },
  permissions() {
    return axios.get("/api/permissions");
  },
  updatePermissions(data) {
    return axios.post("/api/permissions/update", data);
  },

  /**
   * Récupérer le profil du staff actuel
   */
  getCurrentProfile() {
    return axios.get("/api/staff/me");
  },

  /**
   * Récupérer un profil staff par ID (utilise votre méthode existante)
   */
  getProfile(id) {
    return axios.get("/api/staff/" + id);
  },

  /**
   * Mettre à jour le profil staff
   */
  updateProfile(data) {
    return axios.put("/api/user/profile", data);
  },

  // === CALENDLY OAUTH ===

  /**
   * Initier la connexion Calendly
   */
  connectCalendly() {
    return axios.get("/api/oauth/calendly/connect");
  },

  /**
   * Vérifier le statut de la connexion Calendly
   */
  getCalendlyStatus() {
    return axios.get("/api/oauth/calendly/status");
  },

  /**
   * Déconnecter Calendly
   */
  disconnectCalendly() {
    return axios.delete("/api/oauth/calendly/disconnect");
  },

  /**
   * Rafraîchir les tokens Calendly
   */
  refreshCalendly() {
    return axios.post("/api/oauth/calendly/refresh");
  },

  /**
   * Définir le type d'événement Calendly préféré
   */
  setPreferredEventType(eventTypeUri) {
    return axios.post("/api/user/calendly/preferred-event-type", {
      event_type_uri: eventTypeUri
    });
  },

  // === CALENDLY ENTRETIENS ===

  /**
   * Créer un lien de planification Calendly pour un candidat
   */
  createCalendlyInterviewLink(applicationId, interviewerId) {
    return axios.post("/api/candidate/application/interview/calendly", {
      application_id: applicationId,
      interviewer_id: interviewerId
    });
  },

  /**
   * Synchroniser un événement Calendly vers DiMax
   */
  syncCalendlyEvent(applicationId, calendlyEventUri) {
    return axios.post("/api/candidate/application/interview/sync", {
      application_id: applicationId,
      calendly_event_uri: calendlyEventUri
    });
  },

  /**
   * Vérifier les conflits de planning
   */
  checkCalendlyConflicts(date, interviewerId, applicationId) {
    return axios.get("/api/candidate/calendly/check-conflicts", {
      params: {
        date: date,
        interviewer_id: interviewerId,
        application_id: applicationId
      }
    });
  }
};
